// extracted by css-extract-rspack-plugin
export default {"formStyle":"K932b182UiYRnKme","wrapperFields":"fjGglknfjItRurwV","wrappField":"Pv2gukmaQ0kWr9zS"};